<template>
  <v-container class="kim-background">
    <h1 class="headline">{{$i18n.t('ObservationPage.title')}}</h1>
    <p>{{getExercise().name}} {{$i18n.t('ObservationPage.with')}} {{getParticipant().firstName}} {{getParticipant().lastName}}</p>
    <v-row class="text-center">

    </v-row>

    <v-row align="center" class="mt-5">
      <v-col class="col-12 col-lg-8" cols="8">
        <v-row>

          <v-col cols="10" v-if="currentObservation != null">
            <v-text-field :label="$i18n.t('ObservationPage.labelObservationTitle')" v-model="currentObservation.name" @change="onTitleChange"/>
          </v-col>

          <v-col cols="2" v-if="currentObservation != null">
            <v-radio-group v-model="selectedPenInkFormat" @change="penInkFormatChanged" :mandatory="false">
              <template v-for='format in penInkFormats'>
                <v-radio :key='format' :label='$i18n.t(`ObservationPage.${format}`)' :value='format'/>
              </template>
            </v-radio-group>
          </v-col>

          <v-col cols="12" v-if="currentObservation != null">
           <TinyMCE v-model="currentObservation" v-if="currentObservation.penInkFormat === 'html'" @textChanged="onTextChange"/>
           <InkObservation   v-model="currentObservation" v-if="currentObservation.penInkFormat === 'webInk'" @onChanged="onTextChange"/>
          </v-col>

          <v-col cols="12">
            <v-list elevation="2" light>
              <template v-for="(item,i) in getCurrentObservations()">
                <v-list-item v-if="item.deleted !== true" :key="`${i}_${item.modified}`" @click="setObservation(item)" :class="{isHighlighted: item === currentObservation}">

                  <v-list-item-content>
                    <v-list-item-title>{{item.name}} ({{$i18n.t('ObservationPage.page')}} {{item.page}})</v-list-item-title>
                    <v-list-item-subtitle v-if="item.id && item.modified !== true">{{$i18n.t('ObservationPage.statusSync')}}</v-list-item-subtitle>
                    <v-list-item-subtitle v-else>{{$i18n.t('ObservationPage.statusModified')}}</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn icon @click="confirmDeleteObservation(item)">
                      <v-icon color="lighten-1">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list>
          </v-col>

          <v-col cols="12">
            <v-btn @click="saveObservation()" class="mr-2 mb-2"><v-icon color="lighten-1" class="pr-2">mdi-sync</v-icon>{{$i18n.t('ObservationPage.save')}}</v-btn>
            <v-btn @click="displayManual = !displayManual" class="mr-2 mb-2"><v-icon color="lighten-1" class="pr-2">mdi-book-open-page-variant</v-icon>{{$i18n.t('ObservationPage.showManual')}}</v-btn>
            <v-btn class="mr-2 mb-2" @click="addNewObservation"><v-icon color="lighten-1" class="pr-2">mdi-plus</v-icon>{{$i18n.t('ObservationPage.newPage')}}</v-btn>
            <v-btn class="mr-2 mb-2 primary--text" text :to="{name:'assessment'}">
              <span>{{$i18n.t('ObservationPage.nextLink')}}</span>
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </v-col>

        </v-row>

        <v-row v-show="displayManual">
          <v-col cols="12">
            <div class="subtitle-1 mb-2">
              <v-icon class="pr-2 pb-1">mdi-book-open-page-variant</v-icon>{{$i18n.t('ObservationPage.exerciseDocuments')}}
            </div>
            <v-expansion-panels accordion="accordion">
              <v-expansion-panel
                v-for="(item) in currentExerciseDocuments"
                :key="getDocumentKey(item,'exercise')"
              >
                <v-expansion-panel-header><div><v-icon class="pr-2 primary--text">mdi-file-pdf</v-icon>{{item.name}}</div></v-expansion-panel-header>
                <v-expansion-panel-content style="height: 66vh">
                  <Pdf :pdf-url="item.url" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4" align-self="start" class="pl-5 col-12 col-lg-4 mb-10">
        <observation-information :information="currentExercise.information" />
      </v-col>
    </v-row>
    <modal-confirm-dialog :show-dialog="confirmDialog.show" :item="confirmDialog.newFormat" :title="$i18n.t('ObservationPage.switchTypeTitle')" :question="$i18n.t('ObservationPage.switchTypeQuestion')" @confirm="dialogConfirmed(confirmDialog.newFormat)" @decline="dialogDecline(confirmDialog.currentFormat)" @close="confirmDialog.show = false" />
    <modal-confirm-delete :show-dialog="deleteDialog.show" :item="deleteDialog.item" :question="deleteDialog.question" @confirm="deleteObservationConfirmed(deleteDialog.item)" @close="deleteDialog.show = false"/>
  </v-container>
</template>

<script>
import ACTIONS from '@/storeActions';
import { mapGetters, mapState } from 'vuex';
import ModalConfirmDialog from '@/components/ModalConfirmDialog';
import { EventBus, EVENTS } from '../libs/eventBus';
import Pdf from './Pdf.vue';
import TinyMCE from './TinyMCE';
import ObservationInformation from './ObservationInformation';
import BusinessLogicObservation from '../libs/businessLogicObservation';
import ModalConfirmDelete from './ModalConfirmDelete';
import InkObservation from './InkObservation';

export default {
  name: 'Observation',
  components: {
    ModalConfirmDialog,
    Pdf,
    TinyMCE,
    ObservationInformation,
    ModalConfirmDelete,
    InkObservation
  },
  data: () => ({
    penInkFormat: 'html',
    currentObservation: {},
    displayManual: false,
    businessLogic: {}, // dummy, will be created in mount
    penInkFormats: ['html', 'webInk'],
    selectedPenInkFormat: 'html',
    deleteDialog: {
      show: false,
      item: null,
      question: null,
    },
    confirmDialog: {
      show: false,
      newFormat: null,
      currentFormat: null,
    }
  }),
  computed: {
    ...mapGetters(['currentExercise', 'currentExerciseDocuments']),
    ...mapState([
      'user',
      'currentExerciseId',
      'currentParticipantId',
      'runInfo',
      'observations'
    ]),
  },
  methods: {
    penInkFormatChanged(value) {
      Object.assign(this.confirmDialog, {
        show: true,
        newFormat: value,
        currentFormat: this.currentObservation.penInkFormat
      })
    },
    dialogConfirmed(item) {
      this.currentObservation.penInkFormat = item
      this.currentObservation.html = ''
    },
    dialogDecline(item) {
      this.selectedPenInkFormat = item;
    },
    onTextChange(value) {
      // console.log('Observation ontextchange', value);
      // this.$store.dispatch(ACTIONS.UPDATE_OBSERVATIONS, this.currentObservation); //save updates to store
      EventBus.$emit(EVENTS.RESTART_SYNC);
    },
    onTitleChange(value) {
      console.log(value);

      if (!this.currentObservation) {
        return;
      }

      let update = {
        id: this.currentObservation.id,
        temporaryId: this.currentObservation.temporaryId,
        name: value,
        modified: true,
      };

      this.$store.dispatch(ACTIONS.UPDATE_OBSERVATIONS, update); //save updates to store
      this.currentObservation.modified = true;
      //Object.assign(this.currentObservation, update);
      EventBus.$emit(EVENTS.RESTART_SYNC);
    },
    saveObservation() {
      EventBus.$emit(EVENTS.IMMEDIATE_SYNC);
    },
    getExercise() {
      return this.runInfo.exercises.find((x) => x.id === this.currentExerciseId) || {};
    },
    getParticipant() {
      return this.runInfo.participants.find((x) => x.id === this.currentParticipantId) || {};
    },
    getDocumentKey(item, prefix) {
      return `${prefix}${item}`;
    },
    setObservation(observation) {
      this.currentObservation = observation;
      this.selectedPenInkFormat = this.currentObservation.penInkFormat;
    },
    getCurrentObservations() {
      let result = this.observations.filter( (obs) => obs != null && obs.participantId === this.currentParticipantId && obs.exerciseId === this.currentExerciseId);

      // Preselect the first observation in case there is none selected for the current filter
      if (!this.currentObservation || !result.includes(this.currentObservation)) {
        this.currentObservation = result.find( (x) => true );
        if (!this.currentObservation) {
          this.addNewObservation();
        }
        if (this.currentObservation) {
          this.selectedPenInkFormat = this.currentObservation.penInkFormat;
        }
      }
      return result;
    },
    addNewObservation() {
      let format = 'html'
      if (this.currentObservation && this.currentObservation.penInkFormat) {
        this.selectedPenInkFormat = this.currentObservation.penInkFormat
        format = this.currentObservation.penInkFormat
      }
      this.setObservation(this.businessLogic.addNewObservation(format));
      EventBus.$emit(EVENTS.RESTART_SYNC);
    },
    confirmDeleteObservation(item) {
      this.deleteDialog.item = item;
      this.deleteDialog.show = true;
      this.deleteDialog.question = item.name;
    },
    deleteObservationConfirmed(item) {
      this.businessLogic.deleteObservation(item);
      EventBus.$emit(EVENTS.IMMEDIATE_SYNC);
    },
  },
  mounted() {
    this.businessLogic = new BusinessLogicObservation(this);
  },
  beforeDestroy() {
    // fix multiplication of text inserts
    EventBus.$off(EVENTS.MCE_INSERT_TEXT);
  },
};
</script>

<style scoped lang="scss">
  @import '@/ci.scss';

  .isHighlighted {
    background-color: $highlighted;
  }

  .kim-background{
    //z-index:-1;
    background-image: url('/background.svg');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: top 0px right -25px;
    background-size: 55%;

    /*
    opacity: .66;
    top: 20%;
    bottom: -12%;
    right: -8%;
    width: 45%;
    position: fixed;
    */
  }
</style>
